<template>
  <div
    @mouseleave="closeSel"
    class="m-sort"
    :id="id + 'down'"
    :class="{ clickActive: isClick }"
  >
    <!-- click.stop阻止事件向上传播 , 就监听不到document的事件了 -->
    <div
      :style="{
        width:
          type === 'date'
            ? vModel.value
              ? '250px'
              : ''
            : vModel.value
            ? width + 'px'
            : ''
      }"
      :class="id + 'box'"
      class="box clear"
      @mouseenter="showSel"
    >
      <span
        :style="{ width: vModel.value ? '90%' : '' }"
        class="l"
        v-if="type === 'select'"
      >
        {{
          vModel.value
            ? placeholder + ":&nbsp;&nbsp;" + vModel.value
            : placeholder
        }}</span
      >
      <span class="l" v-if="type === 'date'">{{ timeText }}</span>
      <i
        class="fa r"
        style="line-height: 30px; color: #a3a3a3"
        :style="{ 'margin-left': vModel.label ? '-10px' : '10px' }"
        >&#xe620;</i
      >
    </div>
    <transition name="el-zoom-in-top">
      <!-- ,'z-index': isClick ? '2016':0 -->
      <div
        :style="{ width: type === 'date' ? '250px' : '180px'}"
        class="dropDown"
        v-if="isClick"
      >
        <div v-if="type === 'select'">
          <!-- @blurEvent="lab => (vModel2 = lab)" -->
          <by-select
            :id="id"
            :ref="id"
            v-model="curVal"
            @focus="focusInput"
            :select-data="options"
            :setPlaceholder="placeholder"
            style="height: 30px"
            @callEvent="callEvent"
            @keydown.up.native.prevent="keyUp"
            @keydown.down.native.prevent="keyDown"
            @keydown.enter.native="handleKeyEnter"
            sortSel
            @filterOpt="filterOpt"
            :is-input="
              placeholder === 'Consignee' || placeholder === 'Consignor'
            "
            :easy="placeholder === 'Consignee' || placeholder === 'Consignor'"
          >
            <template
              v-if="
                placeholder === 'Departure city' ||
                  placeholder === 'destination country'
              "
            >
              <by-option
                :ref="index"
                :class="{ highlighted: highlightedIndex === index }"
                v-for="(item, index) in options"
                :key="index"
                :item="item"
                :label="`[${item.En}]`"
                :value="item.En"
              >
              </by-option>
            </template>
            <template v-if="placeholder === 'AmazonWarehouse'">
              <by-option
                :ref="index"
                :class="{ highlighted: highlightedIndex === index }"
                v-for="(item, index) in options"
                :key="index"
                :item="item"
                :label="`${item.StoreCode} ${item.CityKey} ${item.PostCode}`"
                :value="`${item.StoreCode} ${item.CityKey} ${item.PostCode}`"
              >
              </by-option>
            </template>
            <template
              v-if="
                placeholder === 'Destination airport' ||
                  placeholder === 'Departure airport'
              "
            >
              <by-option
                :ref="index"
                :class="{ highlighted: highlightedIndex === index }"
                v-for="(item, index) in options"
                :key="index"
                :item="item"
                :label="`${item.Key},${item.En}`"
                :value="`${item.Key},${item.En}}`"
              >
              </by-option>
            </template>
          </by-select>
        </div>
        <!-- <div v-if="type === 'input'"></div> -->
        <div class="time-picker" v-if="type === 'date'">
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            style="width: 250px; height: 30px"
            :placeholder="placeholder"
            range-separator="to"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="clear">
          <div class="l colBlue marL5 clearBtn" style="" @click="clearVal">
            clear
          </div>
          <div class="r sureBtn" @click="enterVal">confirm</div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import BySelect from "./select/bySelect";
import ByOption from "./select/byOption";
import { fuzzyQuery } from "./utils";
import Emitter from "@/utils/emitter";

export default {
  name: "sortSel",
  mixins: [Emitter],

  components: { BySelect, ByOption },
  props: {
    placeholder: String,
    id: String,
    allData: Array,
    type: { type: String, defualt: "select" },
    vModel: { type: Object, defualt: {} },
    width: { type: Number, defualt: 110 }
  },
  // 自定义v-model , 绑定city: {}, //起运城市，//目的国家...
  model: {
    prop: "vModel",
    event: "vModelEvent"
  },

  data() {
    return {
      // vModel2: this.vModel,
      options: [],
      curVal: {},
      dateVal: "",
      isClick: false,
      pickerOptions: {
        disabledDate: function(time) {
          return time.getTime() <= new Date("2018-12-30");
        },
        shortcuts: [
          {
            text: "In the latest week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "The last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "In the past three months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "The last six months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "In recent year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      highlightedIndex: -1
    };
  },
  computed: {},
  watch: {
    dateVal(newVal) {
      if (this.type === "date") {
        this.$emit("vModelEvent", {
          dateVal: this.dateVal
        });
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.clickHundle);
    // console.log(9999);
    // this.callEvent(this.curVal);
  },
  unmounted() {
    document.removeEventListener("click", this.clickHundle);
  },
  computed: {
    timeText() {
      if (this.vModel.dateVal) {
        if (this.vModel.dateVal[0] === this.vModel.dateVal[1]) {
          return this.placeholder + ":" + this.vModel.dateVal[0];
        } else {
          return (
            this.placeholder +
            ":" +
            this.vModel.dateVal[0] +
            "to" +
            this.vModel.dateVal[1]
          );
        }
      } else {
        return this.placeholder;
      }
    }
  },
  methods: {
    //过滤选项
    // filterOpt(text) {
    //   console.log("🚀 ~ text", text);
    // },
    callEvent(lab) {
      console.log("🚀 ~ lab", lab);
    },
    filterOpt(lab) {
      console.log("🚀 ~ lab", lab);
      // debugger;
      // let type = "";
      // if (["Consignee", "发货人"].includes(this.placeholder)) {
      //   type = "person";
      // }

      fuzzyQuery(
        lab,
        searchRes => {
          console.log("🚀 ~ searchRes", searchRes);
          console.log("回调函数被调用");
          this.options = searchRes;
          // debugger;
          this.dispatch("BySelect", "updateScroll");

          // this.$forceUpdate();
        },
        this.allData,
        this.placeholder
      );
    },
    clickHundle(e) {
      if (this.isClick) {
        console.log("🚀 ~ e.target", e.target);

        let sp = document.getElementById(this.id + "down");
        //sp点击选项  选项的li没有被包含
        if (sp && !sp.contains(e.target) && e.target.localName !== "li") {
          this.isClick = false;
        }
      }
    },
    showSel() {
      this.isClick = true;
    },
    closeSel({ toElement }) {
      //当选择时间时,鼠标移出去不隐藏
      if (!toElement.className.includes("el-picker")) {
        this.isClick = false;
      }
    },
    enterVal() {
      if (this.type === "select") {
        console.log("🚀 ~ this.curVal", this.curVal);
        if (
          this.placeholder === "Consignee" ||
          this.placeholder === "Consignor"
        ) {
          this.$emit("vModelEvent", {
            label: this.curVal.label,
            value: this.curVal.label
          });
        } else {
          this.$emit("vModelEvent", this.curVal);
        }
      }
      if (this.type === "date") {
        this.$emit("vModelEvent", {
          dateVal: this.dateVal
        });
      }
      this.isClick = false;
    },
    clearVal() {
      if (this.type === "select") {
        this.$refs[this.id].clearVal();
        this.$emit("vModelEvent", {});
      }
      if (this.type === "date") {
        this.dateVal = "";
        this.$emit("vModelEvent", {});
      }
      this.isClick = false;
    },
    keyUp(e) {
      this.highlightedIndex--;
    },
    keyDown() {
      this.highlightedIndex++;
    },
    handleKeyEnter() {
      console.log("🚀 ~ this.$refs[this.highlightedIndex]", this.$refs);
      this.$refs[this.highlightedIndex][0].chooseSelect();
      this.highlightedIndex = -1;
      this.enterVal();
      // this.$refs[this.id];
      // this.options[this.highlightedIndex];
      // this.isClick = false;
      // this.curVal;
    },
    focusInput() {
      this.filterOpt("");
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  padding: 0 0 0 10px;
  border: 1px solid #d9d9d9;
  background: white;
  border-radius: 5px;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  z-index: 1040;
  position: relative;
  span {
    // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
    -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
    overflow: hidden; /*超出的文本隐藏*/
    text-overflow: ellipsis; /* 溢出用省略号*/
    // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    white-space: nowrap;
     word-break: break-all;
  }
}

.clickActive .box {
  border-radius: 5px 5px 0 0;
  border-bottom: 0px;

  // height: 32px !important;
  // margin-top: -2px;
}
.sureBtn {
  width: 58px;
  height: 23px;
  border: 1px solid #0c5ee4;
  background: #0c5ee4;
  color: #fff;
  border-radius: 25px;
  text-align: center;
  line-height: 23px;
  margin-top: 5px;
  cursor: pointer;
}
.m-sort {
  position: relative;
}

.dropDown {
  position: absolute;
  height: 60px;
  width: 180px;
  padding: 10px;
  margin-top: -1px;
  z-index: 1000;
  border: 1px solid #d9d9d9;
  border-radius: 0 0 5px 5px;
  background: white;
}
.clearBtn {
  line-height: 35px;
  cursor: pointer;
}
.highlighted {
  background-color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/uSortSel.vue